import { arrayNum } from "./arrayNum";

export const arrayIsEmpty = (array) => {
  return arrayNum(array) === 0 ? true : false;
};
